export type CollectionParams = Record<string, string | string[] | undefined>;

export function parseCollectionPage(value: string | null | undefined): number {
  if (!value || !/^[1-9]\d*$/.test(value)) return 1;
  const page = Number(value);
  return Number.isSafeInteger(page) ? page : 1;
}

/** Pagination is a distinct document; filters are not new commercial pages. */
export function collectionIndexing(path: string, params: CollectionParams) {
  const rawPage = params.page;
  const page = parseCollectionPage(
    typeof rawPage === 'string' ? rawPage : undefined
  );
  const invalidPage =
    rawPage !== undefined &&
    (typeof rawPage !== 'string' || String(page) !== rawPage);
  const hasFilters = Object.keys(params).some(
    key => key !== 'page' && params[key] !== undefined
  );
  const noindex = hasFilters || invalidPage;
  return {
    page,
    noindex,
    canonicalPath: !noindex && page > 1 ? `${path}?page=${page}` : path,
  };
}

export function collectionPageHref(
  path: string,
  search: URLSearchParams,
  page: number
): string {
  const params = new URLSearchParams(search);
  if (page <= 1) params.delete('page');
  else params.set('page', String(page));
  const query = params.toString();
  return query ? `${path}?${query}` : path;
}
